import React, {
    useEffect,
    useState,
} from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';

import Head from 'bdvp-common/src/components/Head';
import { useDidUpdate, useMedia } from 'bdvp-common/src/hooks';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

import Message from '../../containers/Message';
import SearchResults from '../../containers/SearchResults';
import NoSearch from './NoSearch';

const SearchPage = (props) => {

    const {
        query,
        queryInfoError,
        setSelectedFilters,
        resetPageNumber,
        closeFilterModal,
        openFilterModal,
    } = props;

    const location = useLocation();
    const dictionary = useDictionary();

    const [
        isClient,
        setIsClient,
    ] = useState(false);

    useEffect(() => {

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

    }, [location.search]);

    useDidUpdate(()=>{

        resetPageNumber();

    },[query]);

    const isLargeBreakpoint = useMedia(
        [`(min-width: ${BREAKPOINTS.lg})`],
        [true],
        false
    );

    useEffect(() => {

        setIsClient(true);
        Tracking.trackSearchResultsPageView();

        return () => {

            setSelectedFilters([]);
            resetPageNumber();

        };

    }, []);

    useEffect(() => {

        isLargeBreakpoint && openFilterModal();

        return () => {

            closeFilterModal();

        };

    }, [isLargeBreakpoint]);

    let content;

    if(!isClient) {

        content = null;

    } else if(!query) {

        content = <NoSearch />;

    } else if (queryInfoError) {

        content = <Message type={'search_error'} />;

    } else {

        content = <SearchResults query={query} />;

    }

    return (
        <>
            <Head
                title={dictionary.searchpage_title ?? 'Baseball Video Search | MLB Film Room'}
                description={dictionary.searchpage_description ?? 'Search MLB video highlights by player, team, matchups, and stats.'}
            />
            {content}
        </>
    );

};

SearchPage.propTypes = {
    setSelectedFilters: PropTypes.func.isRequired,
    resetPageNumber: PropTypes.func.isRequired,
    closeFilterModal: PropTypes.func.isRequired,
    openFilterModal: PropTypes.func.isRequired,
    query: PropTypes.string,
    queryInfoError: PropTypes.object,
};

SearchPage.defaultProps = {
    query: '',
    queryInfoError: undefined,
};

export default SearchPage;
